module.exports = __webpack_public_path__ + "images/790e9a62ed657d8775e13d045f50c58f.svg";